import React from 'react';
import {isMobile} from 'react-device-detect';
import LazyLoad from 'react-lazyload';
import ContentData from './data/ContentData.js'
import {
    Container,
    Col,
    Row
  } from 'reactstrap';

  import { UncontrolledCarousel } from 'reactstrap';
  import ReactCompareImage from 'react-compare-image';
  
let w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
let wide= w>1600?1:0

// let zoom1 = isMobile?1:1+wide
// let zoom2 = isMobile?1:2+wide
let zoom4 = isMobile?3+wide:4+wide
// let zoom5 = isMobile?4:5+wide
let zoom6 = isMobile?5+wide:6+wide
let zoom7 = isMobile?6+wide:7+wide
let zoommobile = isMobile?3:7+wide

let mobilecoord = isMobile?[32.0878015,9.2141812]:[31.0365579,30.8331165]
let zoom8 = isMobile?7+wide:8+wide
// let zoom9 = isMobile?8:9+wide
let zoom10 = isMobile?9+wide:10+wide
// let zoom11 = isMobile?10:11+wide
let pitch0 = isMobile?0:0
// let pitch20 = isMobile?10:20
let pitch40 = isMobile?10:40
let pitch50 = isMobile?20:50


let deltaintro = <section><section style={ isMobile ? { paddingTop:0} : {paddingTop : "80vh"} } className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].data4}</h3>
    <img style={isMobile ? { display:"block", paddingBottom:"15px"} : {display : "none"}} src='./jpg/slider/originalslide.jpg' alt=""/>

    <p>{ContentData[1].data4}</p>
        <img src='./jpg/cotton.jpg' alt=""/>
        <img src='./jpg/infographics/watercrops.png' alt=""/>
    </section>
</section>
</section>



let deltachart = <section><section className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].data5}</h3>
    <p>{ContentData[1].data5}</p>
    {/* <img src= "./gif/scenarios.gif" alt=""/> */}
    <LazyLoad height={500} offset={800}>
    <div className="embed-responsive embed-responsive-16by9">
    <iframe title="scenarios" className="filldam" src="https://player.vimeo.com/video/386232204?autoplay=0&loop=0&autopause=0&muted=0&title=0&byline=0&portrait=0&sidedock=0/"></iframe>
    </div>
    </LazyLoad>
    </section>
</section>
</section>

let scenario4 = <section><section className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].scenario21}</h3>
    <p>{ContentData[1].scenario21}</p>

    <LazyLoad height={500} offset={800}>
    <img src= "./jpg/infographics/scenario21.png" alt=""/>
<img className="reducemargin" src= "./gif/scenario21a.gif" alt=""/>
<section className="slideboxar"><ReactCompareImage rightImage="./jpg/slider/originalslide.jpg" leftImage="./jpg/slider/scenario21slidear.jpg" /></section>
</LazyLoad>
    </section>
</section>
</section>

let scenario1 = <section><section className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].data6}</h3>
    <p>{ContentData[1].data6}</p>
    {/* <img src= "./gif/scenario10.gif" alt=""/> */}
    <LazyLoad height={500} offset={800}>
    <img src= "./jpg/infographics/scenario10.png" alt=""/>
    <img className="reducemargin" src= "./gif/scenario10a.gif" alt=""/>
    <section className="slideboxar"><ReactCompareImage rightImage="./jpg/slider/originalslide.jpg" leftImage="./jpg/slider/scenario10slidear.jpg" /></section>
</LazyLoad>
    </section>
</section>
</section>

let scenario2 = <section><section className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].data7}</h3>
    <p>{ContentData[1].data7}</p>
    {/* <img src= "./gif/scenario7.gif" alt=""/> */}
    <LazyLoad height={500} offset={800}>
    <img src= "./jpg/infographics/scenario7.png" alt=""/>
    <img className="reducemargin" src= "./gif/scenario7a.gif" alt=""/>
    <section className="slideboxar"><ReactCompareImage rightImage="./jpg/slider/originalslide.jpg" leftImage="./jpg/slider/scenario7slidear.jpg" /></section>
</LazyLoad>
    </section>
</section>
</section>

let scenario3 = <section><section className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].data8}</h3>
    <p>{ContentData[1].data8}</p>
    {/* <img src= "./gif/scenario5.gif" alt=""/> */}
    <LazyLoad height={500} offset={800}>
    <img src= "./jpg/infographics/scenario5.png" alt=""/>
    <img className="reducemargin" src= "./gif/scenario5a.gif" alt=""/>
    <section className="slideboxar"><ReactCompareImage rightImage="./jpg/slider/originalslide.jpg" leftImage="./jpg/slider/scenario5slidear.jpg" /></section>
</LazyLoad>
    </section>
</section>
</section>


let scenario5 = <section><section className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].scenario3}</h3>
    <p>{ContentData[1].scenario3}</p>
    {/* <img src= "./gif/scenario5.gif" alt=""/> */}
    <LazyLoad height={500} offset={800}>
    <img src= "./jpg/infographics/scenario3.png" alt=""/>
    <img className="reducemargin" src= "./gif/scenario3a.gif" alt=""/>
    <section className="slideboxar"><ReactCompareImage rightImage="./jpg/slider/originalslide.jpg" leftImage="./jpg/slider/scenario3slidear.jpg" /></section>
</LazyLoad>
    </section>
</section>
</section>

let storyofthenile = <section><section className="chapter">
    <Container fluid className="nile fullscreen">
        <Row className="justify-content-center align-items-center">
            <Col lg="12" md="12" xs="12" className="text-left">
                <h1 className="display-1 white text-center">{ContentData[0].datanile}</h1>
            </Col>
        </Row>
    </Container>
</section>
</section>

let nileoverall = <section><section className="chapter">
    <section className="minwidth solidbordernoborder"><h3 className="bluebox">{ContentData[0].data9}</h3>
    <img style={isMobile ? { display:"block", paddingBottom:"15px"} : {display : "none"}} src='./jpg/slider/climatear.jpg' alt=""/>

    <p>{ContentData[1].data9}</p>
    <LazyLoad height={500} offset={800}><img src= "./gif/nileriverar.gif" alt=""/></LazyLoad>
    </section>
</section>
</section>

let nilecompare = <section><section className="chapter">
    <section className="minwidth solidbordernoborder"><h3 className="bluebox">{ContentData[0].data10}</h3>
    <p>{ContentData[1].data10}</p>
        <LazyLoad height={500} offset={800}>
    <div className="embed-responsive embed-responsive-16by9">
    <iframe title="nileexplainer" className="filldam" src="https://player.vimeo.com/video/386232357?autoplay=0&loop=0&autopause=0&muted=0&title=0&byline=0&portrait=0&sidedock=0/"></iframe>
    </div>
    </LazyLoad>
    <LazyLoad height={500} offset={800}><img src= "./gif/nilespeciala.gif" alt=""/></LazyLoad>

    </section>
    </section>
    </section>

let ownsnile = <section><section className="chapter">
    <section className="minwidth solidbordernoborder"><h3 className="bluebox">{ContentData[0].data11}</h3>
    <p>{ContentData[1].data11}</p>
    {/*<img src= "./gif/ownsnile.gif" alt=""/>*/}

    <LazyLoad height={500} offset={800}><img src= "./jpg/infographics/ownsnile.png" alt=""/></LazyLoad> 

</section>
</section>
</section>

let basinoverall = <section><section className="chapter">
<section className="minwidth"><h3 className="bluebox">{ContentData[0].data13}</h3>
<img style={isMobile ? { display:"block", paddingBottom:"15px"} : {display : "none"}} src='./jpg/slider/basinar.jpg' alt=""/>

<p>{ContentData[1].data13}</p>
{/*<img src= "./gif/nilebasin.gif" alt=""/>*/}
     <LazyLoad height={500} offset={800}><img src= "./jpg/infographics/banks.png" alt=""/></LazyLoad> 

</section>
</section>
</section>


let game1 = <section><section className="chapter">
    <section className="maxwidth gamegrey">
<Container fluid className="gamegrey">
        <Row className="justify-content-center align-items-center">
            <Col lg="8" md="10" xs="12" className="text-left">
                <br/>
            {/* <h1 className="gametext display-2 text-center">Can you guess where your country ranks?</h1> */}
            <h2 className="display-4 white bold text-center">{ContentData[0].game1ex}</h2>
            <p className="white text-center max800">{ContentData[1].game1ex}</p>
            <LazyLoad height={500} offset={800}><img src= "./jpg/games/water.jpg" alt=""/></LazyLoad>
            <small className="white text-left">المصدر  : Natural Earth</small>
            <h2 className="display-4 white bold text-center">{ContentData[0].game1}</h2>

            <p className="white text-center max800">{ContentData[1].game1}</p>
            <LazyLoad height={500} offset={800}><div><iframe title="flourish1" src='./flourish/flourishar.html' frameBorder='0' scrolling='no' style={{width:"100%",height:"470px"}}></iframe></div></LazyLoad>
            </Col>
        </Row>
    </Container>
<section className="gamegrey gamebox"><article style={{"width":"150px", "position": "relative", "float":"right", "right": "10px"}}><a href="https://flourish.studio/?utm_source=embed" target='_top'><img alt="Made with Flourish" width="120" height="auto" src="./flourish/made_with_flourish.svg"/></a></article></section>
</section>
</section>

</section>

let storyofthedam = <section><section className="chapter">
<section className="minwidth"><h3 className="bluebox">{ContentData[0].dam1}</h3>
<p>{ContentData[1].dam1}</p>
<LazyLoad height={500} offset={800}><img src= "./jpg/infographics/journey.png" alt=""/></LazyLoad>
</section>
</section>
</section>


let gotoethiopia = <section><section className="chapter">
    <Container fluid className="tana fullscreen">
        <Row className="justify-content-center align-items-center">
            <Col lg="12" md="12" xs="12" className="text-left">
                <h1 className="display-1 white text-center">{ContentData[0].data14}</h1>
                <h2 className="display-4 white text-center">{ContentData[1].data14}</h2>
            </Col>
        </Row>
    </Container>
</section>
</section>

let tana = <section><section className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].data15}</h3>
    <p>{ContentData[1].data15}</p>
    {/* <img src= "./gif/howformed.gif" alt=""/> */}
    <LazyLoad height={500} offset={800}><img src= "./gif/tanaa.gif" alt=""/></LazyLoad>
    </section>
</section>
</section>



let dam = <section><section className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].data16}</h3>
    <p>{ContentData[1].data16}</p>
    <LazyLoad height={500} offset={800}>
    <div className="embed-responsive embed-responsive-16by9">
        <iframe title="dam" className="filldam" src="https://player.vimeo.com/video/372811428?autoplay=1&loop=1&autopause=0&muted=1&title=0&byline=0&portrait=0&sidedock=0/"></iframe>
    </div>
    </LazyLoad>
    <LazyLoad height={500} offset={800}>
    <img src='./jpg/infographics/gerd.png' alt=""/>
    <img src='./jpg/infographics/largest.png' alt=""/>
    </LazyLoad>
    </section>
</section>
</section>



let game2 = <section><section className="chapter">
    <section className="maxwidth gamegrey">
<Container fluid className="gamegrey">
        <Row className="justify-content-center align-items-center">
            <Col lg="8" md="10" xs="12" className="text-left">
            {/* <h1 className="gametext display-2 text-right">Can you guess where your country ranks?</h1> */}
            <h2 className="display-4 white bold text-center">{ContentData[0].game2ex}</h2>
            <p className="white text-center max800">{ContentData[1].game2ex}</p>
            <p className="labels arabic text-center white">   <span style={{"backgroundColor":"#f44336"}}> الوقود الأحفوري </span> <span style={{"backgroundColor":"#00bcd4"}}> المائية </span>   <span style={{"backgroundColor":"#ffeb3b"}}> النووية </span> <span style={{"backgroundColor":"#3f51b5"}}> الرياح </span> <span style={{"backgroundColor":"#ff9800"}}> الشمسية </span>  <span style={{"backgroundColor":"#795548"}}> الحرارية </span> <span style={{"backgroundColor":"#607d8b"}}> أخرى </span> </p>
            <LazyLoad height={500} offset={800}><img src= "./jpg/games/pp.jpg" alt=""/></LazyLoad>
            <small className="white text-left">المصدر  : World Resources Institute</small>
            <h2 className="display-4 white bold text-center">{ContentData[0].game2}</h2>

            <p className="white text-center max800">{ContentData[1].game2}</p>
            <LazyLoad height={500} offset={800}><div><iframe title="flourish2" src='./flourish2/flourishar.html' frameBorder='0' scrolling='no' style={{width:"100%",height:"470px"}}></iframe></div></LazyLoad>
            </Col>
        </Row>
    </Container>
<section className="gamegrey gamebox"><article style={{"width":"150px", "position": "relative", "float":"right", "right": "10px"}}><a href="https://flourish.studio/?utm_source=embed" target='_top'><img alt="Made with Flourish" width="120" height="auto" src="./flourish/made_with_flourish.svg"/></a></article></section>
</section>
</section>
</section>



let addis = <section><section className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].data17}</h3>
    <p>{ContentData[1].data17}</p>
    <LazyLoad height={500} offset={800}>
        <div className="embed-responsive embed-responsive-16by9">
    <iframe title="addis" className="filldam" src="https://player.vimeo.com/video/372817537?autoplay=1&loop=1&autopause=0&muted=1&title=0&byline=0&portrait=0&sidedock=0/"></iframe>
    </div>
    </LazyLoad>
    <LazyLoad height={500} offset={800}><img src='./jpg/infographics/ethiopiaelectricity.png' alt=""/></LazyLoad>
    </section>
</section>
</section>

let game3 = <section><section className="chapter">
    <section className="maxwidth gamegrey">
<Container fluid className="gamegrey">
        <Row className="justify-content-center align-items-center">
            <Col lg="8" md="10" xs="12" className="text-left">
            {/* <h1 className="gametext display-2 text-right">Can you guess where your country ranks?</h1> */}
            <h2 className="display-4 white bold text-center">{ContentData[0].game3ex}</h2>
            <p className="white text-center max800">{ContentData[1].game3ex}</p>
            <p className="labels text-center white"><span style={{"backgroundColor":"#f44336"}}> طاقة تقليدية </span> <span style={{"backgroundColor":"#00bcd4"}}> طاقة نظيفة </span></p>
            <LazyLoad height={500} offset={800}><img src= "./jpg/games/clean.jpg" alt=""/></LazyLoad>
            <small className="white text-left">المصدر  : World Resources Institute</small>
            <h2 className="display-4 white bold text-center">{ContentData[0].game3}</h2>

            <p className="white text-center max800">{ContentData[1].game3}</p>
            <LazyLoad height={500} offset={800}><div><iframe title="flourish3" src='./flourish3/flourishar.html' frameBorder='0' scrolling='no' style={{width:"100%",height:"470px"}}></iframe></div></LazyLoad>
            </Col>
        </Row>
    </Container>
    <section className="gamegrey gamebox"><article style={{"width":"150px", "position": "relative", "float":"right", "right": "10px"}}><a href="https://flourish.studio/?utm_source=embed" target='_top'><img alt="Made with Flourish" width="120" height="auto" src="./flourish/made_with_flourish.svg"/></a></article></section>

</section>
</section>
</section>


let gotosudan = <section><section className="chapter">
    <Container fluid className="sudan fullscreen">
        <Row className="justify-content-center align-items-center">
            <Col lg="12" md="12" xs="12" className="text-left">
                <h1 className="display-1 white text-center">{ContentData[0].data18}</h1>
                <h2 className="display-4 white text-center">{ContentData[1].data18}</h2>
            </Col>
        </Row>
    </Container>
</section>
</section>

let sudan = <section><section className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].data19}</h3>
    <img style={isMobile ? { display:"block", paddingBottom:"15px"} : {display : "none"}} src='./jpg/slider/triangle.jpg' alt=""/>

    <p>{ContentData[1].data19}</p>
    <LazyLoad height={500} offset={800}>
    <div className="embed-responsive embed-responsive-16by9">
        <iframe title="sudan" className="filldam" src="https://player.vimeo.com/video/372818813?autoplay=1&loop=1&autopause=0&muted=1&title=0&byline=0&portrait=0&sidedock=0/"></iframe>
    </div>
    </LazyLoad>
    </section>
</section>
</section>


let khartoum =<section><section className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].data20}</h3>
    <p>{ContentData[1].data20}</p>
    <LazyLoad height={500} offset={800}><img src='./jpg/infographics/sudanelectricity.png' alt=""/></LazyLoad>
<br/>
<br/>
    </section>
    </section>
</section>

let gotoegypt = <section><section className="chapter">
    <Container fluid className="cairo fullscreen">
        <Row className="justify-content-center align-items-center">
            <Col lg="12" md="12" xs="12" className="text-left">
                <h1 className="display-1 white text-center">{ContentData[0].data21}</h1>
                <h2 className="display-4 white text-center">{ContentData[1].data21}</h2>
            </Col>
        </Row>
    </Container>
</section>
</section>


const aswanimages = [
    {
      src: './jpg/aswan.jpg',
      altText: '',
      header: '',
      caption: '',
      key: '1'
    },
    {
      src: './jpg/aswan2.jpg',
      altText: '',
      caption: '',
      header: '',
      key: '2'
    }
  ];


let aswan = <section><section className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].data22}</h3>
    <p>{ContentData[1].data22}</p>
    <LazyLoad height={500} offset={800}><UncontrolledCarousel items={aswanimages} /></LazyLoad>
    </section>
</section>
</section>


let cairo = <section><section className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].data24}</h3>
    <p>{ContentData[1].data24}</p>
    <LazyLoad height={500} offset={800}><img src='./jpg/history.jpg' alt=""/></LazyLoad>
    </section>
</section>
</section>

let egypt = <section><section className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].data25}</h3>
    <p>{ContentData[1].data25}</p>
    <LazyLoad height={500} offset={800}>    <img src='./jpg/infographics/egyptelectricity.png' alt=""/>
</LazyLoad>
    </section>
</section>
</section>


let egyptsolutions = <section><section className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].data32}</h3>
    <p>{ContentData[1].data32}</p>
    <LazyLoad height={500} offset={800}>
    <div className="embed-responsive embed-responsive-16by9">
    <iframe title="solutions" className="filldam" src="https://player.vimeo.com/video/386232079?autoplay=0&loop=0&autopause=0&muted=0&title=0&byline=0&portrait=0&sidedock=0/"></iframe>
    </div>
    </LazyLoad>
    <LazyLoad height={500} offset={800}><img src='./jpg/infographics/egyptdo.png' alt=""/></LazyLoad>
    </section>
</section>
</section>


let gotoafrica = <section><section className="chapter">
    <Container fluid className="future fullscreen">
        <Row className="justify-content-center align-items-center">
            <Col lg="12" md="12" xs="12" className="text-left">
                <h1 className="display-1 white text-center">{ContentData[0].data26}</h1>
                <h2 className="display-4 white text-center">{ContentData[1].data26}</h2>
            </Col>
        </Row>
    </Container>
</section>
</section>

const damimages = [
    {
      src: './jpg/inga.jpg',
      altText: '',
      header: '',
      caption: '',
      key: '1'
    },
    {
        src: './jpg/solai.jpg',
        altText: '',
        header: '',
        caption: '',
        key: '2'
      },
    {
      src: './jpg/marwi.jpg',
      altText: '',
      caption: '',
      header: '',
      key: '3'
    },
    {
        src: './jpg/rosaires.jpg',
        altText: '',
        caption: '',
        header: '',
        key: '4'
      }
  ];
let futuredams = <section><section className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].data27}</h3>
    <p>{ContentData[1].data27}</p>
    <LazyLoad height={500} offset={800}>
    <UncontrolledCarousel items={damimages} />
</LazyLoad>
<LazyLoad height={500} offset={800}><img src='./jpg/infographics/africaelectricity.png' alt=""/></LazyLoad>
    </section>
    </section>
</section>

let farmingcrops = <section><section className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].data23}</h3>
    <p>{ContentData[1].data23}</p>
    </section>
</section>
</section>


let scientists = <section><section className="chapter">
    <section className="minwidth solidborder"><h3 className="bluebox">{ContentData[0].data28}</h3>
    <p>{ContentData[1].data28}</p>
    <LazyLoad height={500} offset={800}><img src='./jpg/farming.jpg' alt=""/></LazyLoad>

    </section>
    </section>
</section>




var config = {
    style: 'mapbox://styles/ajjerusalem/ck5pgogs62gl01imrmu6hayh1?optimize=true',
    accessToken: 'pk.eyJ1IjoiYWpqZXJ1c2FsZW0iLCJhIjoiY2l4b2t3N2lyMDAxMzJxcHMwZ3IzOWN1OSJ9.cxZW0ZgGPFDZpc_-JtRBxg',
    showMarkers: false,
    theme: 'light',
    alignment: 'center',
    chapters: [
        {
            id: 'deltaintro',
            description: deltaintro,
            location:{
                center: mobilecoord,
                bearing: 0,
                zoom: zoommobile,
                pitch: pitch0,
                speed: 0.2
            },
            onChapterEnter:[
                {
                    layer: 'slidescenario0',
                    opacity: 1
                }
            ],
            onChapterExit:[
            ]
        },
        {
            id: 'deltachart',
            description: deltachart,
            location:{
                center: [31.0365579,30.8331165],
                bearing: 0,
                zoom: zoom7,
                pitch: pitch0,
                speed: 0.2
            },
            onChapterEnter:[
            ],
            onChapterExit:[
                { 
                    layer: 'slidescenario0',
                    opacity: 0
                },
            ]
        },
        {
            id: 'scenario4',
            description: scenario4,
            location:{
                center: [31.0365579,30.8331165],
                bearing: 0,
                zoom: zoom7,
                pitch: pitch0,
                speed: 0.2
            },
            onChapterEnter:[
                {
                    layer: 'slidescenario4',
                    opacity: 0.95
                },
            ],
            onChapterExit:[
                {
                    layer: 'slidescenario4',
                    opacity: 0
                },
            ]
        },
        {
            id: 'scenario1',
            description: scenario1,
            location:{
                center: [31.0365579,30.8331165],
                bearing: 0,
                zoom: zoom7,
                pitch: pitch0,
                speed: 0.2
            },
            onChapterEnter:[
                {
                    layer: 'slidescenario1',
                    opacity: 0.95
                },
            ],
            onChapterExit:[
                {
                    layer: 'slidescenario1',
                    opacity: 0
                },
            ]
        },
        {
            id: 'scenario2',
            description: scenario2,
            location:{
                center: [31.0365579,30.8331165],
                bearing: 0,
                zoom: zoom7,
                pitch: pitch0,
                speed: 0.2
            },
            onChapterEnter:[
                {
                    layer: 'slidescenario2',
                    opacity: 0.95
                },
            ],
            onChapterExit:[
                { 
                    layer: 'slidescenario2',
                    opacity: 0
                },
            ]
        },
        {
            id: 'scenario3',
            description: scenario3,
            location:{
                center: [31.0365579,30.8331165],
                bearing: 0,
                zoom: zoom7,
                pitch: pitch0,
                speed: 0.2
            },
            onChapterEnter:[
                {
                    layer: 'slidescenario3',
                    opacity: 0.95
                },
            ],
            onChapterExit:[
                {
                    layer: 'slidescenario3',
                    opacity: 0
                },
            ]
        },
        {
            id: 'scenario5',
            description: scenario5,
            location:{
                center: [31.0365579,30.8331165],
                bearing: 0,
                zoom: zoom7,
                pitch: pitch0,
                speed: 0.5
            },
            onChapterEnter:[
                {
                    layer: 'slidescenario5',
                    opacity: 0.95
                },
            ],
            onChapterExit:[
                {
                    layer: 'slidescenario5',
                    opacity: 0
                },
            ]
        },
        {
            id: 'storyofthenile',
            description: storyofthenile,
            location:{
                center: [32.0878015,9.2141812],
                        zoom: zoom4,
                        pitch: pitch50,
                        speed: 0.5,
                        bearing: 0
            },
            onChapterEnter:[
                                {
                    layer: 'ne-10m-admin-0-countries-1-65dtpd',
                    opacity: 0.95
                },
            ],
            onChapterExit:[
            ]
        },
        {
            id: 'nileoverall',
            description: nileoverall,
            location:{
                center: [32.0878015,9.2141812],
                        zoom: zoom4,
                        pitch: pitch50,
                        speed: 0.5,
                        bearing: 0
            },
            onChapterEnter:[
                {
                    layer: 'climatezone',
                    opacity: 0.8
                }
            ],
            onChapterExit:[
            ]
        },
        {
            id: 'nilecompare',
            description: nilecompare,
            location:{
                center: [32.0878015,9.2141812],
                        zoom: zoom4,
                        pitch: pitch50,
                        speed: 0.5,
                        bearing: 0
            },
            onChapterEnter:[
            ],
            onChapterExit:[
 
            ]
        },
        {
            id: 'ownsnile',
            description: ownsnile,
            location:{
                center: [32.0878015,9.2141812],
                        zoom: zoom4,
                        pitch: pitch50,
                        speed: 0.5,
                        bearing: 0
            },
            onChapterEnter:[
            ],
            onChapterExit:[
                {
                    layer: 'climatezone',
                    opacity: 0
                }
            ]
        },
        {
            id: 'basinoverall',
            description: basinoverall,
            location:{
                center: [32.0878015,9.2141812],
                        zoom: zoom4,
                        pitch: pitch50,
                        speed: 0.5,
                        bearing: 0
            },
            onChapterEnter:[
                {
                    layer: 'basinshape-43hkad',
                    opacity: 0.4
                }
            ],
            onChapterExit:[
            ]
        },
        {
            id: 'game1',
            description: game1,
            location:{
                center: [32.0878015,9.2141812],
                        zoom: zoom4,
                        pitch: pitch50,
                        speed: 0.5,
                        bearing: 0
            },
            onChapterEnter:[
            ],
            onChapterExit:[
                {
                    layer: 'basinshape-43hkad',
                    opacity: 0.05
                }
            ]
        },                
        {
            id: 'storyofthedam',
            description: storyofthedam,
            location: {
                center: [38.6634179,11.0485208],
                zoom: zoom6,
                pitch: pitch50,
                speed: 0.5,
                bearing: 0
            },
            onChapterEnter: [
            ],
            onChapterExit: [
            ]
        },
        {
            id: 'gotoethiopia',
            description: gotoethiopia,
            location: {
                center: [38.6634179,11.0485208],
                zoom: zoom6,
                pitch: pitch50,
                speed: 0.2,
                bearing: 0
            },
            onChapterEnter: [
            ],
            onChapterExit: [
            ]
        },
        {
            id: 'tana',
            description: tana,
            location: {
                center: [37.274339,11.9699761],
                zoom: zoom7,
                pitch: 0,
                speed: 0.5,
                bearing: 0
            },
            onChapterEnter: [
                {
                    layer: 'waterway',
                    opacity: 1
                }
                
            ],
            onChapterExit: [
                {
                    layer: 'waterway',
                    opacity: 0
                }
            ]
        },
        {
            id: 'dam',
            description: dam,
            location: {
                center: [35.0903839,11.2141852],
                zoom:zoom8,
                pitch: 0,
                speed: 0.5,
                bearing: 0
            },
            onChapterEnter: [  
            ],
            onChapterExit: [
            ]
        },
        {
        id: 'game2',
        description: game2,
            location: {
                center: [35.0903839,11.2141852],
                zoom:zoom8,
                pitch: 0,
                speed: 0.5,
                bearing: 0
            },
        onChapterEnter:[
        ],
        onChapterExit:[
        ]
    },                 
        {
            id: 'addis',
            description: addis,
            location: {
                center: [38.6634179,11.0485208],
                zoom: zoom6,
                pitch: pitch40,
                speed: 0.5,
                bearing: 0
            },
            onChapterEnter: [  
            ],
            onChapterExit: [
            ]
        },
        {
            id: 'game3',
            description: game3,
            location: {
                center: [38.6634179,11.0485208],
                zoom: zoom6,
                pitch: pitch40,
                speed: 0.5,
                bearing: 0
            },
                onChapterEnter:[
                ],
                onChapterExit:[
                ]
        },  
        {
            id: 'gotosudan',
            description: gotosudan,
            location: {
                center: [32.4652652,15.6064832],
                zoom: zoom6,
                pitch: pitch40,
                speed: 0.5,
                bearing: 0
            },
            onChapterEnter: [
            ],
            onChapterExit: [
            ]
        },
        {
            id: 'sudan',
            description: sudan,
            location: {
                center: [32.4652652,15.6064832],
                zoom: zoom8,
                pitch: 0,
                speed: 0.5,
                bearing: 0
            },
            onChapterEnter: [
            ],
            onChapterExit: []
        },
        {
            id: 'khartoum',
            description: khartoum,
            location: {
                center: [32.4652652,15.6064832],
                zoom: zoom6,
                pitch: pitch40,
                speed: 0.5,
                bearing: 0
            },
            onChapterEnter: [
            ],
            onChapterExit: []
        },
        {
            id: 'gotoegypt',
            description: gotoegypt,
            location: {
                center: [32.8750812,23.970883],
                zoom: zoom6,
                pitch: pitch40,
                speed: 0.5,
                bearing: 0
            },
            onChapterEnter: [
            ],
            onChapterExit: [ 
            ]
        },
        {
            id: 'cairo',
            description: cairo,
            location: {
                center: [31.7780523,22.5393592],
                zoom: zoom8,
                pitch: 0,
                bearing: 0,
                speed: 0.5
            },
            onChapterEnter: [
            ],
            onChapterExit: []
        },
        {
            id: 'aswan',
            description: aswan,
            location: {
                center: [32.8750812,23.970883],
                zoom: zoom8,
                pitch: 0,
                speed: 0.5,
                bearing: 0
            },
            onChapterEnter: [
            ],
            onChapterExit: []
        },
        {
            id: 'egypt',
            description: egypt,
            location: {
                center: [32.8750812,23.970883],
                zoom: zoom6,
                pitch: pitch40,
                bearing: 0,
                speed: 0.5
            },
            onChapterEnter: [
            ],
            onChapterExit: []
        },
        {
            id: 'egyptsolutions',
            description: egyptsolutions,
            location: {
                center: [32.8750812,23.970883],
                zoom: zoom6,
                pitch: pitch40,
                bearing: 0,
                speed: 0.5
            },
            onChapterEnter: [
            ],
            onChapterExit: []
        },
        {
            id: 'gotoafrica',
            description: gotoafrica,
            location:{
                center: [32.0878015,10.2141812],
                bearing: 0,
                zoom: zoom4,
                pitch: pitch50,
                speed: 0.5
            },
            onChapterEnter:[
            ],
            onChapterExit:[]
        },
        {
            id: 'futuredams',
            description: futuredams,
            location: {
                center: [32.0878015,10.2141812],
                zoom: zoom4,
                pitch: pitch50,
                speed: 0.5,
                bearing: 0
            },
            onChapterEnter:[
            ],
            onChapterExit: []
        },
        {
            id: 'farmingcrops',
            description: farmingcrops,
            location: {
                center: [32.0878015,10.2141812],
                zoom: zoom4,
                pitch: pitch50,
                bearing: 0,
                speed: 0.5
            },
            onChapterEnter: [
            ],
            onChapterExit: []
        },
        {
            id: 'scientists',
            description: scientists,
            location: {
                center: [32.0878015,10.2141812],
                zoom: zoom4,
                pitch: pitch50,
                speed: 0.5,
                bearing: 0
            },
            onChapterEnter:[],
            onChapterExit: []
        }

     ]};
 export default config;